<script>
import Vue from "vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import Loader from "@/components/widgets/loader";
import { uuid } from 'vue-uuid';
import Swal from "sweetalert2";
import XLSX from "xlsx"
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import yukleniyor from "../../FormComponet/loader.vue";

export default {
  mixins: [Api, Sabit],
  props: ["Raporgirisid", "DetayId", "DonemId", "BirimId", "TabloDetayAciklama", "Hesaplanmasin", "AltDonemlerDetay", "UstDonemId"],

  components: {
    Loader,
    Treeselect,
    yukleniyor,
  },
  data() {
    return {
      uuid: uuid.v4(),
       loading:1,
       loadingnew: false,

      FormData: [],
      Message: {
        position: "",
        icon: "",
        title: "",
        showConfirmButton: false,
        timer: 1500,
      },


      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      FormElemanlari: [],
      TabloVerileri: [],
      TabloDetayVerileri: [],
      Parametreler: [],
      ComboboxDonemler: [],
      ExceldenOkunan: [],
      veri_tipleri: [],
      ComboData: "",
      AllHedefData: [],
      hesap_parametre: "",
      hesap_yontemi: 0,
      hesaplanan_parametre: "",
      keys: [],
      gizle:0,
      degerler: [],
      DataUpdate: "",
      AddEdit: "",
      okunanverijson: [],
      avesisokunanverijson:[],
      excel_kayit_listesi: [],
      ComboboxVar: 0,
      errors: [],
      Filter: {
        secilen_Donem: "",
        aktarilan_donem: "",
      },
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
    };
  },


  watch: {
    Id() {
      //this.FormData = this.Id;

    },

    DetayId() {
      this.Get();
    },
  },

  methods: {
    onSubmit() {
      this.parametre_kontrol(1);    //normal kayıt
    },

    parametre_kontrol(islem) {


      let hesaplama_kontrol = 0;

      let Filter = "&Tablodetayid=" + this.DetayId + "&Asc=Sirano";

      this.ActionsFilterGet({ Service: "StrPerfTablolarDetayParametre", Page: this.Page, Filter: Filter }).then(res => {

        for (var i = 0; i < res.Data.length; i++) {

          if (res.Data[i].Hesaplamayontemi != null && res.Data[i].Hesaplamayontemi != "") {

            hesaplama_kontrol = 1;
            this.hesaplanan_parametre = res.Data[i].Tablodetayparametreid;
            this.hesap_yontemi = res.Data[i].Hesaplamayontemi;

          }

        }

        if (hesaplama_kontrol == 1) {

          let deger_kontrol = 0;

          for (var s = 0; s < this.FormData.length; s++) {
            if (this.FormData[s].Parametreid == this.hesaplanan_parametre && this.FormData[s].Deger == "" && islem == 1) {
              deger_kontrol = 1;
            }

          }

          if (deger_kontrol == 0) {

            if (islem == 1) {
              this.formu_kaydet();
            }
            if (islem == 2) {
              this.EcxelKaydet();
            }

          } else {

            this.Message.position = "center";
            this.Message.icon = "warning";
            this.Message.title = "Uyarı!";
            this.Message.showConfirmButton = false;
            this.Message.timer = 100000;

            Vue.swal("Parametre türü için geçersiz veri");

          }



        } else {

          this.Message.position = "center";
          this.Message.icon = "warning";
          this.Message.title = "Uyarı!";
          this.Message.showConfirmButton = false;
          this.Message.timer = 100000;

          Vue.swal("Parametre Hesaplama Yöntemi Girilmemiş");


        }



      });


    },
    ExcelExport(table, name){

      setTimeout(() => {

          if (!table.nodeType) table = this.$refs.StrDetayParametreleri;
          var html =table.innerHTML
          var ctx = {worksheet: name || 'Worksheet', table:html }
          var a = document.createElement('a');
          a.href = this.uri +this.base64(this.format(this.template, ctx));
          a.download = name + '.xls';
          a.click();

      }, 1000);

      },
      validateForm() {

      this.errors = this.FormData.map(item => {

        return !item.Deger || item.Deger.length === 0;
      });

      return !this.errors.includes(true);
    },
ExcelExport2(table, name) {
    this.gizle = 1;

    setTimeout(() => {
        if (!table.nodeType) table = this.$refs.strdetayparametresablon;

        const worksheet = XLSX.utils.table_to_sheet(table);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, name || 'Sheet1');

        const excelData = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelData], { type: 'application/octet-stream' });

        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = `${name || 'Export'}.xlsx`;
        a.click();

        this.gizle = 0;
    }, 500);
},
formatIfDate(value) {
    const formatRegex = /^[A-Za-z]{3} [A-Za-z]{3} \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT[+-]\d{4} \(GMT[+-]\d{2}:\d{2}\)$/;
    
    if (typeof value !== 'string' || !formatRegex.test(value)) {
        return value;
    }

    const parsed = new Date(value);
    if (isNaN(parsed.getTime())) {
        return value;
    }

    const gun = String(parsed.getDate()).padStart(2, "0");
    const ay = String(parsed.getMonth() + 1).padStart(2, "0");
    const yil = parsed.getFullYear();

    return `${gun}.${ay}.${yil}`;
},
    formu_kaydet() {
    if(this.validateForm()){
      if (this.AddEdit == "Add") {
        for(var Data in this.FormData){
          if(typeof this.FormData[Data].Deger == 'object'){

            this.FormData[Data].Deger =  JSON.stringify(this.FormData[Data].Deger);
          }
        }
        this.Post("StrPerfTablolarDetayParametreGiris/PostList", this.FormData).then((res) => {
          if (res) {
            if (this.Hesaplanmasin == false) {

              this.detay_say();

            }
          }
        });

      } else {
        let count = 0
        for(var Data2 in this.FormData){
          count += 1;
          if(typeof this.FormData[Data2].Deger == 'object'){

            this.FormData[Data2].Deger =  JSON.stringify(this.FormData[Data2].Deger);
          }
          if(this.FormData[Data2].Groupguid == ""|| this.FormData[Data2].Groupguid == null){
            this.FormData[Data2].Groupguid = this.FormData[0].Groupguid;
            this.FormData[Data2].Id = uuid.v4();
            this.Post("StrPerfTablolarDetayParametreGiris", this.FormData[Data2],false).then((resp) => {
                 if (resp) {
                  this.FormData[Data2].Id = resp;


                 }
              });

          }



          if(count == this.FormData.length){
            this.AllUpdate("StrPerfTablolarDetayParametreGiris/PutList", this.FormData).then((res) => {
          if (res) {

            if (this.Hesaplanmasin == false) {

              this.detay_say();
            }

          }

        });
          }

        }



      }
}else{
              this.Message.position = "center";
            this.Message.icon = "warning";
            this.Message.title = "Uyarı!";
            this.Message.showConfirmButton = false;
            this.Message.timer = 100000;

            Vue.swal("Tüm Parametreleri Doldurunuz!");
}
    },

    form_olustur(detayid, guid) {

      this.uuid = uuid.v4();
      this.FormElemanlari = [];
      this.FormData = [];
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

      let Filter = "&Groupguid=" + guid + "&Asc=Parametreid";
      this.ActionsFilterGet({ Service: "StrPerfTablolarDetayParametreGiris", Page: Page, Filter: Filter }).then((res2) => {


        let Filter = "&Tablodetayid=" + detayid + "&Asc=Sirano";

        this.ActionsFilterGet({ Service: "StrPerfTablolarDetayParametre", Page: this.Page, Filter: Filter }).then(res => {


          for (var i = 0; i < res.Data.length; i++) {

            let parametre_adi = res.Data[i].j_Parametreadi;
            let parametre_id = res.Data[i].Tablodetayparametreid;
            let Hesaplamayontemi = res.Data[i].Hesaplamayontemi;

            let data_tipi = "";
            for (var s = 0; s < this.veri_tipleri.length; s++) {
              if (res.Data[i].j_Tip == this.veri_tipleri[s].Id) {
                data_tipi = this.veri_tipleri[s].Value;
              }
            }


            if (data_tipi != 'Combobox') {
              this.FormElemanlari.push({
                "FieldTitle": parametre_adi, "FieldType": data_tipi,
                "Parametreid": parametre_id, "Hesaplamayontemi": Hesaplamayontemi
              });
            } else {
              this.ComboboxVar = 1;
              this.ActionsSingleGet({
                Service: "StrPerfTablolarDetayParametreTanim",
                Id: parametre_id,
              }).then((res) => {


                let Filter = "&Ustid=" + res.Data.Comboboxveribaslikid + "&UstidDoluMu=true";
                this.ActionsFilterGet({ Service: "StrPerfTablolarDetayParametreHedefTanim", Page: this.Page, Filter: Filter }).then((resp) => {
                  var Data =  resp.Data.sort((a, b) => a.Sira - b.Sira);
                  var ComboboxData = []

                  ComboboxData.push({
                    id: '',
                    label: 'Tümünü Seç',
                    children: [],
                  });
                  for (var i = 0; i < Data.length; i++) {
                    ComboboxData[0].children.push({ id: Data[i].Id, label: Data[i].Hedefadi })
                  }
                  this.FormElemanlari.push({
                    "FieldTitle": parametre_adi, "FieldType": data_tipi,
                    "Parametreid": parametre_id, "Hesaplamayontemi": Hesaplamayontemi, "ComboboxData": ComboboxData
                  });
                });




              });

            }


            if (this.AddEdit == "Add") {

              if(data_tipi != 'Combobox'){
                this.FormData.push({
                Deger: "",
                Deleted: false,
                Birimid: this.BirimId,
                Donemid: this.DonemId,
                Tablodetayid: this.DetayId,
                Parametreid: parametre_id,
                Groupguid: this.uuid
              },);
              }else{
                this.FormData.push({
                Deger: [],
                Deleted: false,
                Birimid: this.BirimId,
                Donemid: this.DonemId,
                Tablodetayid: this.DetayId,
                Parametreid: parametre_id,
                Groupguid: this.uuid
              },);
              }


            } else {


              if (this.AddEdit == "Edit") {
                if(data_tipi != 'Combobox'){
                  this.FormData.push({
                  Deger: "",
                  Deleted: false,
                  Birimid: this.BirimId,
                  Donemid: this.DonemId,
                  Tablodetayid: this.DetayId,
                  Parametreid: parametre_id,
                  Groupguid: "",
                  Id: ""
                },);

                }else{
                  this.FormData.push({
                  Deger: "",
                  Deleted: false,
                  Birimid: this.BirimId,
                  Donemid: this.DonemId,
                  Tablodetayid: this.DetayId,
                  Parametreid: parametre_id,
                  Groupguid: "",
                  Id: ""
                },);
                }





                let gelen_data = res2.Data;

                for (var k = 0; k < gelen_data.length; k++) {

                  for (var m = 0; m < this.FormData.length; m++) {

                    if (gelen_data[k].Parametreid == this.FormData[m].Parametreid) {

                      this.FormData[m].Groupguid = gelen_data[k].Groupguid;
                      this.FormData[m].Id = gelen_data[k].Id;
                      if(gelen_data[k].Deger[0]!="["){
                        this.FormData[m].Deger = gelen_data[k].Deger;
                      }else{
                        this.FormData[m].Deger = JSON.parse(gelen_data[k].Deger);
                      }


                    }

                  }

                }

              }

            }

          }


        });
      });
    },

    kayit_duzelt(guid, DetayId) {


      this.form_olustur(DetayId, guid);


    },
    WhicHedef(data){
      var label = "";
      for (var i = 0; i < this.AllHedefData.length; i++) {

              if(data == this.AllHedefData[i].id)
              {
                label = this.AllHedefData[i].label
              }

        }
      return label
    },
    Get() {

      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

                this.ActionsFilterGet({ Service: "StrPerfTablolarDetayParametreHedefTanim", Page: Page, Filter: "&UstidDoluMu=true" }).then((resp) => {
                  this.AllHedefData = []
                  var Data =  resp.Data.sort((a, b) => a.Sira - b.Sira);
                    for (var i = 0; i < Data.length; i++) {

                        this.AllHedefData.push({ id: Data[i].Id, label: Data[i].Hedefadi })


                  }


                });

      this.donem_getir(this.DonemId, this.DetayId, this.BirimId);



      let sorgu = "&Tip=1561";
      let Tip = [];

      this.ActionsFilterGet({ Service: "OKeyValues", Page: Page, Filter: sorgu }).then((res) => {
        console.log(res)
        for (var i = 0; i < res.Data.length; i++) {
          if (res.Data[i].Kod == 1 || res.Data[i].Kod == 2) {

            Tip.push(res.Data[i].Id);

          }

        }

        let altsorgu = "&UstId=" + this.UstDonemId + "&UstIdDoluMu=true&Approval=true&VeriTipi=3";

        let tipler = "";

        for (var s = 0; s < Tip.length; s++) {

          tipler = tipler + "&TipId=" + Tip[s];

        }

        altsorgu = altsorgu + tipler;



        this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu }).then((res) => {
          for (var i = 0; i < res.Data.length; i++) {

            this.ComboboxDonemler.push(res.Data[i]);

          }
        });

      });


    },

    donem_aktar() {

      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

      //Eski Group Guidlere karşılık yenileri oluşturuluyor
      let grupguidler = [];
      let yeni_guid = ""
      for (var i = 0; i < this.TabloVerileri.length; i++) {
        yeni_guid = uuid.v4();
        grupguidler.push({ "Eski": this.TabloVerileri[i].groupguid, "Yeni": yeni_guid });
      }


      let Filter = "&Birimid=" + this.BirimId + "&Donemid=" + this.Filter.secilen_Donem + "&Tablodetayid=" + this.DetayId;
      this.ActionsFilterGet({ Service: "StrPerfTablolarDetayParametreGiris", Page: Page, Filter: Filter }).then((res) => {

        let gelen_veri = res.Data;

        for (i = 0; i < gelen_veri.length; i++) {
          gelen_veri[i].Donemid = this.Filter.aktarilan_donem;
          this.$delete(gelen_veri[i], "Id");

          //Yeni Group Guidlere eskilerin yerine güncelleniyor
          for (var s = 0; s < grupguidler.length; s++) {
            if (gelen_veri[i].Groupguid == grupguidler[s].Eski) {
              gelen_veri[i].Groupguid = grupguidler[s].Yeni;
            }
          }

        }

        console.log(JSON.stringify(gelen_veri));



        this.Post("StrPerfTablolarDetayParametreGiris/PostList", gelen_veri).then((res) => {
          if (res) {
            this.detay_say();
          }

        });



      });




    },

    isEditor(pub) {
        const authors = pub.authors?.toLowerCase() ?? "";
        const ref = pub.reference?.primary?.toLowerCase() ?? "";


        return (
          authors.includes("editör") || authors.includes("editor") ||
          ref.includes("editör") ||  ref.includes("editor") 
        );
    },


    AvesisOku() {

       var AvesisKod = this.AltDonemlerDetay.AvesisKod;
       this.okunanverijson=[];
       var avesisokunan=[];

      var serviceName="publication";


       if (AvesisKod==9 || AvesisKod==10){
            serviceName="journaldutyscore";
       }
     

     let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

     let Filter = "Donemid=" + this.DonemId + "&Tablodetayid=" + this.DetayId + "&BirimId=" + this.BirimId + 
     "&beginDate="+this.AltDonemlerDetay.BaslamaTarihi+"&endDate="+this.AltDonemlerDetay.BitisTarihi+
     "&serviceName="+serviceName+"&Asc=Sirano";

     console.log(JSON.stringify(Filter));

        this.loading=0;
         this.loadingnew=true;
      this.ActionsFilterGet({ Service: "StrPerfTablolarDetayParametreGiris/GetAvesisSorgula", Page: Page, Filter: Filter }).then((res) => {
        
          var YayinListesi = res.Data.YayinListesi;
    

          var liste =[];

           for (var i = 0; i < YayinListesi.length; i++) {

               if (YayinListesi[i]?.Veri?.result?.length > 0) {

                  for (var j=0; j < YayinListesi[i].Veri.result.length; j++)
                  {
                       YayinListesi[i].Veri.result[j].AdSoyad = YayinListesi[i].AdSoyad;
                       liste.push(YayinListesi[i].Veri.result[j]);
                  }

                }

           }
               

            for (var s = 0; s < liste.length; s++) {

              var ekle=0;
              var tip=0;
               
          if (AvesisKod != 9 && AvesisKod != 10){

              var yazarlar = liste[s]?.authors;
              var yazar_sayisi = yazarlar ? yazarlar.split(',').length : 0;
              var makale_adi = liste[s]?.title.primary;
              var doi_numarasi = liste[s]?.doi;
              var yayinevi = liste[s]?.publisherName;
              
              var yayin_tarihi = liste[s]?.publishDate;
       
              var bildiri_cesidi = liste[s]?.conferencePaperPresentationTypeName?.primary;
              var bildiri_turu = liste[s]?.congressName;
              var bolum_adi = liste[s]?.chapterTitle?.primary;

              var journalTypeId = liste[s]?.journalTypeId;
              var isInternational = liste[s]?.isInternational;
             
              var publicationTypeCode = liste[s]?.publicationTypeCode;

          } else {
              var AdSoyad = liste[s]?.AdSoyad;
              var journalName = liste[s]?.journalName;
              var journalDutyTypeId = liste[s]?.journalDutyTypeId;
                 journalTypeId = liste[s]?.journalTypeId;
                 isInternational = liste[s]?.isInternational;

                 var dergi_editor = false;
                 if ( journalDutyTypeId==1 || journalDutyTypeId==2  || journalDutyTypeId==3  
                 || journalDutyTypeId==4 || journalDutyTypeId==5  ){
                    dergi_editor = true;
                 }
          }

              
              if (publicationTypeCode=="MA"){
              let articleQuartiles = liste[s]?.articleQuartiles?.wosQuarter
                ?? liste[s]?.articleQuartiles?.scopusQuarter
                ?? liste[s]?.articleQuartiles?.schimagoQuarter;

                  if (!articleQuartiles || ["null", "undefined", ""].includes(articleQuartiles.toString().trim().toLowerCase())) {
                    articleQuartiles = "YOK";
                  }
             
              
                        if (AvesisKod=="1" && articleQuartiles=="Q1" && publicationTypeCode=="MA"){ ekle=1; tip=1; }
                        if (AvesisKod=="2" && articleQuartiles=="Q2" && publicationTypeCode=="MA"){ ekle=1; tip=1; }
                        if (AvesisKod=="3" && articleQuartiles=="Q3" && publicationTypeCode=="MA"){ ekle=1; tip=1; }
                        if (AvesisKod=="4" && articleQuartiles=="Q4" && publicationTypeCode=="MA"){ ekle=1; tip=1; }
            
                        if(ekle==1 &&  tip==1){
                      
                            avesisokunan.push({
                              "Makale adı": makale_adi,
                              "Yazarların adı-soyadı": yazarlar,
                              "Yazar sayısı": yazar_sayisi,
                              "DOİ numarası": doi_numarasi
                            });
                          }

                      //  console.log("AvesisKod:"+AvesisKod, "articleQuartiles:"+articleQuartiles, "publicationTypeCode:"+publicationTypeCode,"isInternational:"+isInternational);

                        if (AvesisKod=="5" && articleQuartiles=="YOK" && publicationTypeCode=="MA" && isInternational == true){ ekle=1; tip=2;}

                        if (AvesisKod=="6" && articleQuartiles=="YOK" && publicationTypeCode=="MA" && isInternational == false &&
                          (journalTypeId==1 || journalTypeId==3)){ ekle=1;  tip=2;}

                          if(ekle==1 && tip==2){

         
                            avesisokunan.push({
                              "Makalenin Konusu": makale_adi,
                              "Yazarın adı": yazarlar,
                              "DOİ numarası": doi_numarasi
                            });
                          }

              }


              const editor = this.isEditor(liste[s]);

              if (AvesisKod=="7" &&  (publicationTypeCode=="KE" || publicationTypeCode=="KB") && isInternational==false
               && editor==true ){ ekle=1; tip=3; }

                
              if (AvesisKod=="8" &&  (publicationTypeCode=="KE" || publicationTypeCode=="KB") && isInternational==true
               && editor==true ){ ekle=1; tip=3; }

               if(ekle==1 && tip==3){
                  avesisokunan.push({
                    "Kitabın adı": makale_adi,
                    "Editörün Adı-Soyadı": yazarlar
                  });
                }

              console.log("AvesisKod:"+AvesisKod,  "isInternational:"+isInternational,"dergi_editor:"+dergi_editor,"journalTypeId:"+journalTypeId);

              if (AvesisKod=="9" && isInternational==false  && dergi_editor==true && (journalTypeId==1 || journalTypeId==3)){ ekle=1; tip=4;}

              if (AvesisKod=="10" && isInternational==true  && dergi_editor==true && (journalTypeId==1 || journalTypeId==3)){ ekle=1; tip=4;}
                if(ekle==1 && tip==4){
                  avesisokunan.push({
                    "Derginin adı": journalName,
                    "Editörün Adı-Soyadı": AdSoyad
                  });
                }


              if (AvesisKod=="11"  && publicationTypeCode=="BI" && isInternational==false ){ ekle=1; tip=5; }

              if (AvesisKod=="12"  && publicationTypeCode=="BI" && isInternational==true ){ ekle=1; tip=5; }
                if(ekle==1 && tip==5){

                  avesisokunan.push({
                    "Yazarların adı-soyadı": yazarlar,
                    "Bildirinin Adı": makale_adi,
                    "Bildirinin sunulduğu tarih": yayin_tarihi,
                    "Türü(Kongre/Sempozyum vb.)": bildiri_turu,
                    "Bildirinin çeşidi (Sözlü/Poster)":bildiri_cesidi
                    
                  });
                }


              if (AvesisKod=="13" &&  publicationTypeCode=="KE"  && isInternational==false  && editor==false ){ ekle=1;  tip=6;}

              if (AvesisKod=="14" &&  publicationTypeCode=="KE"  && isInternational==true  ){  ekle=1; tip=6; }
              
              if(ekle==1 && tip==6){
                avesisokunan.push({
                    "Yazarın adı": yazarlar,
                    "Kitabın adı": makale_adi,  
                    "Yayınevi": yayinevi,
                    "Yayın tarihi": yayin_tarihi
                  });
                }
                
             // console.log("AvesisKod:"+AvesisKod,  "publicationTypeCode:"+publicationTypeCode, "isInternational:"+isInternational,"editor:"+editor);

              if (AvesisKod=="15" &&  publicationTypeCode=="KB"  && isInternational==false  && editor==false ){ ekle=1;  tip=7;}

              if (AvesisKod=="16" &&  publicationTypeCode=="KB"  && isInternational==true   && editor==false ){ ekle=1;  tip=7;}
                if(ekle==1 && tip==7){
                avesisokunan.push({
                    "Yazarın adı": yazarlar,
                    "Kitabın adı": makale_adi,  
                    "Bölüm adı": bolum_adi,
                    "Yayın tarihi": yayin_tarihi
                  });
                }
                


            }



            this.okunanverijson=avesisokunan;

            this.loadingnew=false;
            this.loading = 1;

          //console.log("Okunan: "+JSON.stringify(this.avesisokunanverijson));

      });   
  
    },





    donem_getir(donemid, detayid, birimid) {

      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

      let Filter = "&Donemid=" + donemid + "&Tablodetayid=" + detayid + "&BirimId=" + birimid + "&Asc=Sirano";

      this.ActionsFilterGet({ Service: "StrPerfTablolarDetayParametreGiris/GetPivotByDonemidDetayid", Page: Page, Filter: Filter }).then((res) => {

        this.TabloVerileri = res;
        this.keys = Object.keys(this.TabloVerileri[0]);


      });
    },

    performans_kaydet(veri) {

      if (veri) {

        if (veri.Deger != null) {

          this.$delete(veri, "DonemAdi");
          this.$delete(veri, "BaslamaTarihi");
          this.$delete(veri, "BitisTarihi");
          this.$delete(veri, "HedefMi");
          this.$delete(veri, "Onay");

          if (veri.Id == "00000000-0000-0000-0000-000000000000" || veri.id == "") {

            this.$delete(veri, "Id");

            this.Post("StrPerfRaporGiris", veri, false).then((res) => {
              if (res) {
                this.AltDonemlerDetay.Id = res.Data;
                this.$emit("TabloyuGuncelle");
                try {
                  this.$bvModal.hide("StrPerfTablolarDetayParametreGiris");
                } catch (err) {
                  console.log(err)
                }

                try {
                  this.$bvModal.hide("ExcelOku");
                } catch (err) {
                  console.log(err)
                }

              }
            });

          } else {


            this.Update("StrPerfRaporGiris", veri, false).then((res) => {
              if (res) {

                this.$emit("TabloyuGuncelle");
                try {
                  this.$bvModal.hide("StrPerfTablolarDetayParametreGiris");
                } catch (err) {
                  console.log(err)
                }

                try {
                  this.$bvModal.hide("ExcelOku");
                } catch (err) {
                  console.log(err)
                }

              }
            });

          }

        } else {
          this.$toast.error(this.$t('Lütfen geçerli bir değer giriniz!'));
        }

      }

    },

    sil(grupid) {

      Swal.fire({
        title: this.$t("ToasMessage.DeletePopupBaslik"),
        text: this.$t("ToasMessage.DeletePopupContent"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: this.$t("ToasMessage.DeletePopupPozitif"),
        cancelButtonText: this.$t("ToasMessage.DeletePopupNegatif"),
      }).then((result) => {
        if (result.value) {

          this.ActionsDelete({ Service: 'StrPerfTablolarDetayParametreGiris/DeleteByGroupGuid', Id: grupid }).then((res) => {
            if (res.Succeeded == true) {
              this.detay_say()
            }

          });
        }
      });
    },

    detay_say() {

      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

      let yontem = 0;
      let Filter = "&Tablodetayid=" + this.DetayId;

      this.ActionsFilterGet({ Service: "StrPerfTablolarDetayParametre", Page: this.Page, Filter: Filter }).then(res => {

        for (var i = 0; i < res.Data.length; i++) {

          if (res.Data[i].Hesaplamayontemi != null && res.Data[i].Hesaplamayontemi != "") {

            if (res.Data[i].Hesaplamayontemi == 2) {
              yontem = 2;
            } else {
              yontem = 1;
            }

            this.hesap_parametre = res.Data[i].Tablodetayparametreid;
          }

        }


        this.degerler = [];
        Filter = "&Birimid=" + this.BirimId + "&Donemid=" + this.DonemId + "&Tablodetayid=" +
          this.DetayId + "&Parametreid=" + this.hesap_parametre;


        this.ActionsFilterGet({ Service: "StrPerfTablolarDetayParametreGiris", Page: Page, Filter: Filter }).then((res) => {

          this.degerler = res.Data;


          if (yontem == 2) {

            let toplam = 0;

            for (i = 0; i < this.degerler.length; i++) {

              toplam = toplam + parseInt(this.degerler[i].Deger);
            }


            this.AltDonemlerDetay.Deger = toplam;


          } else {
            let group_kontrol = [];

            for (i = 0; i < this.degerler.length; i++) {

              var varmi = group_kontrol.indexOf(this.degerler[i].Groupguid);

              if (varmi < 0) {

                group_kontrol.push(this.degerler[i].Groupguid);

              }

            }

            this.AltDonemlerDetay.Deger = group_kontrol.length;
          }

          this.performans_kaydet(this.AltDonemlerDetay);

        });






      });




    },

    onChange(event) {
      this.okunanverijson = [];
      this.file = null;

      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: 'binary', cellDates: true, dateNF: 'yyyy/mm/dd;@' });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          this.ExceldenOkunan = XLSX.utils.sheet_to_json(ws, { header: 1 });


          if (this.ExceldenOkunan[0].length == this.FormElemanlari.length) {
            let satir = "";
            for (var i = 1; i < this.ExceldenOkunan.length; i++) {
              satir = "";
              var Data = {}
              for (var baslik = 0; baslik < this.ExceldenOkunan[0].length; baslik++) {
                if (satir != "") { satir = satir + ","; } else { satir = satir + "{"; }
                satir = satir + "" + this.ExceldenOkunan[0][baslik] + ":" + this.ExceldenOkunan[i][baslik];
                Data[this.ExceldenOkunan[0][baslik]] = this.ExceldenOkunan[i][baslik]
              }
              satir = satir + "}";

              this.okunanverijson.push(Data);

            }


            for (i = 0; i < this.okunanverijson.length; i++) {

              var keyCount = Object.keys(this.okunanverijson[i]).length;

              for (var s = 0; s < keyCount; s++) {

                if (this.FormElemanlari[s].FieldType == "Tarih") {

                  let deger = new Date(Object.values(this.okunanverijson[i])[s]);
                  deger.setDate(deger.getDate() + 1);

                  let yeni = this.$options.filters.formatDateTable(deger)

                  this.okunanverijson[i][Object.keys(this.okunanverijson[i])[s]] = yeni;

                }
                if (this.FormElemanlari[s].FieldType == "Combobox") {


                    this.okunanverijson[i][Object.keys(this.okunanverijson[i])[s]] = this.FormElemanlari[s].FieldTitle



                    this.okunanverijson[i][Object.values(this.okunanverijson[i])[s]] = [];




                  }

              }

            }
          } else {
            this.$toast.error(
              this.$t("Excel Tablosu Parametre Sayısı Hatalı!")
            );
          }

        }

        reader.readAsBinaryString(this.file);
      }
    },

    ExcelSil(satir) {
      this.okunanverijson.splice(satir, 1);
    },

    EcxelKaydet() {

      this.excel_kayit_listesi = [];

      let kontrol = 0;

      for (var i = 0; i < this.okunanverijson.length; i++) {
        let guid = uuid.v4();


        var keyCount = Object.keys(this.okunanverijson[i]).length;


        for (var s = 0; s < keyCount; s++) {

          if (this.hesaplanan_parametre == this.FormElemanlari[s].Parametreid && this.hesap_yontemi == 2) {
            if (isNaN(Object.values(this.okunanverijson[i])[s])) {
              kontrol = 1;
            }

          }

        }

        if (kontrol == 0) {

          for (s = 0; s < keyCount; s++) {
            if(this.FormElemanlari[s].FieldType=='Combobox'){

              this.excel_kayit_listesi.push({
              "Birimid": this.BirimId,
              "Deger": JSON.stringify(Object.values(this.okunanverijson[i])[s]) ,
              "Deleted": false,
              "Donemid": this.Filter.aktarilan_donem,
              "Groupguid": guid,
              "Parametreid": this.FormElemanlari[s].Parametreid,
              "Parametretip": this.FormElemanlari[s].FieldType,
              "Tablodetayid": this.DetayId
            });
            }
            else{
              this.excel_kayit_listesi.push({
              "Birimid": this.BirimId,
              "Deger": "" + Object.values(this.okunanverijson[i])[s],
              "Deleted": false,
              "Donemid": this.Filter.aktarilan_donem,
              "Groupguid": guid,
              "Parametreid": this.FormElemanlari[s].Parametreid,
              "Parametretip": this.FormElemanlari[s].FieldType,
              "Tablodetayid": this.DetayId
            });
            }


          }

        }


      }

      if (kontrol == 0) {


        this.Post("StrPerfTablolarDetayParametreGiris/PostList", this.excel_kayit_listesi).then((res) => {
          if (res) {

            this.detay_say();
          }

        })

      } else {

        this.Message.position = "center";
        this.Message.icon = "warning";
        this.Message.title = "Uyarı!";
        this.Message.showConfirmButton = false;
        this.Message.timer = 100000;

        Vue.swal("Parametre türü için geçersiz veri");

      }



    },
    updateData(rowIndex, cellIndex, value) {
    // Doğrudan ilgili veriyi güncelliyoruz


    this.okunanverijson[rowIndex][cellIndex] = value;
  },


    toplu_sil() {

      Swal.fire({
        title: this.$t("ToasMessage.DeletePopupBaslik"),
        text: this.$t("ToasMessage.DeletePopupContent"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: this.$t("ToasMessage.DeletePopupPozitif"),
        cancelButtonText: this.$t("ToasMessage.DeletePopupNegatif"),
      }).then((result) => {
        if (result.value) {

          this.ActionsDelete({
            Service: 'StrPerfTablolarDetayParametreGiris/DeleteByDonemidBirimid/' + this.DonemId + '/' + this.BirimId + '/' + this.DetayId, Id: ""
          }).then((res) => {
            if (res.Succeeded == true) {
              this.detay_say()
            }

          });
        }
      });


    }


  },

  created() {

    this.Filter.aktarilan_donem = this.DonemId;
    this.donem_getir(this.DonemId, this.DetayId, this.BirimId);

    this.ActionsSabitGet(1558).then(res => {
      this.veri_tipleri = res.Data;
    });

  },

};
</script>

<template>
  <Loader>
    <div>
      <div class="row mb-2">
        <div class="col-sm-8">
          <h4>{{ TabloDetayAciklama }} </h4>

        <!--
                          {{Hesaplanmasin}}<br>
        birim :{{BirimId}}<br>
        {{Filter.secilen_Donem}}<br>
        Detay : {{DetayId}}<br>
        Donem :{{Filter.aktarilan_donem}}<br> -->
        </div>
      </div>
      <div class="row mb-2">  
     
          <div
            v-if="AltDonemlerDetay.Onay == 0 || AltDonemlerDetay.Onay == null"
            class="text-sm-end"
          >
          
            <button
              type="button"
              class="btn btn-success btn-rounded mb-2 me-2"
              @click="ExcelExport('Detay Parametreleri', 'Detay Parametreleri')"
            >
              <i class="mdi mdi-file-export-outline me-1"></i>
              Excel'e Aktar
            </button>
            <button
              type="button"
              class="btn btn-secondary rounded-pill mb-2 me-2"
              v-b-modal.ExcelOku
              @click="(AddEdit = 'Add'), form_olustur(DetayId)"
            >
              <i class="mdi mdi-microsoft-excel me-1"></i>
              {{ this.$t("StrPerfTablolarDetayParametreGiris.Page.ExcelOku") }}
            </button>
            
            
             <button  v-if="AltDonemlerDetay.AvesisKod != null && AltDonemlerDetay.AvesisKod > 0"
              type="button"
              class="btn btn-success btn-rounded mb-2 me-2"
              v-b-modal.AvesisOku
              @click="(AddEdit = 'Add'), form_olustur(DetayId), AvesisOku()"
            >
              <i class="mdi mdi-database-search-outline me-1"></i>
              Avesis'ten Oku
            </button>
            
            
            <button
              type="button"
              class="btn btn-primary btn-rounded mb-2 me-2"
              v-b-modal.StrPerfTablolarDetayParametreGiris
              @click="(AddEdit = 'Add'), form_olustur(DetayId)"
            >
              <i class="mdi mdi-plus me-1"></i>
              {{
                this.$t("StrPerfTablolarDetayParametreGiris.Page.YeniKayitEkle")
              }}
            </button>
          </div>
        
      </div>
      <hr v-if="AltDonemlerDetay.Onay == 0 || AltDonemlerDetay.Onay == null" />

      <div
        v-if="AltDonemlerDetay.Onay == 0 || AltDonemlerDetay.Onay == null"
        class="row"
      >
        <div class="col-md-5">
          <b-form-group
            class="mb-3"
            id="donemler"
            :label="$t('StrPerfTablolarDetayParametreGiris.Page.Donem')"
            label-for="text"
          >
            <select
              v-model="Filter.secilen_Donem"
              @change="donem_getir(Filter.secilen_Donem, DetayId, BirimId)"
              class="form-select"
              type="text"
            >
              <option
                v-for="DonemVerileri in ComboboxDonemler"
                :key="DonemVerileri.Id"
                :value="DonemVerileri.Id"
              >
                {{ DonemVerileri.Aciklama }}
              </option>
            </select>
          </b-form-group>
        </div>

        <div class="col-md-2">
          <b-form-group class="mb-3" id="gdonemler" label="." label-for="text">
            <div class="button-items">
              <button
                style="width:99%; margin-bottom:20px"
                type="button"
                @click="donem_aktar"
                class="btn btn-primary"
              >
                {{
                  this.$t("StrPerfTablolarDetayParametreGiris.Page.BtnAktar")
                }}
              </button>
            </div>
          </b-form-group>
        </div>

        <div class="col-md-5">
          <b-form-group
            class="mb-3"
            id="donemler"
            :label="$t('StrPerfTablolarDetayParametreGiris.Page.AktifDonem')"
            label-for="text"
          >
            <select
              v-model="Filter.aktarilan_donem"
              @change="gdonem_combo_yukle(Filter.aktarilan_donem)"
              Disabled
              class="form-select"
              type="text"
            >
              <option
                v-for="DonemVerileri in ComboboxDonemler"
                :key="DonemVerileri.Id"
                :value="DonemVerileri.Id"
              >
                {{ DonemVerileri.Aciklama }}
              </option>
            </select>
          </b-form-group>
        </div>
      </div>

      <hr />

      <div class="table-responsive">
        <table
          class="table table-striped table-bordered mb-0"
          ref="StrDetayParametreleri"
        >
          <tbody>
            <tr>
              <th v-for="(Data, index) in keys" :key="index" scope="col">
                <div v-if="Data != 'groupguid' && Data != 'TotalCount'">
                  {{ Data }}
                </div>
              </th>

              <th
                v-if="
                  AltDonemlerDetay.Onay == 0 || AltDonemlerDetay.Onay == null
                "
                scope="col"
              >
                İşlem
              </th>
            </tr>

            <tr v-for="Data in TabloVerileri" :key="Data.Id">
              <td v-for="(fild, index) in Data" :key="index">
                <div v-if="fild == null"></div>
                <div v-else>
                  <div
                    v-if="
                      index != 'groupguid' &&
                        index != 'TotalCount' &&
                        fild[0] != '['
                    "
                  >
            {{ formatIfDate(fild) }}
                  </div>
                  <div
                    v-if="
                      index != 'groupguid' &&
                        index != 'TotalCount' &&
                        fild[0] == '['
                    "
                  >
                    <div
                      v-for="(subfild, index3) in JSON.parse(fild)"
                      :key="index3"
                    >
                      {{ WhicHedef(subfild) }}
                    </div>
                  </div>
                </div>
              </td>

              <td
                v-if="
                  AltDonemlerDetay.Onay == 0 || AltDonemlerDetay.Onay == null
                "
              >
                <i
                  style="margin-left:10px"
                  v-b-modal.StrPerfTablolarDetayParametreGiris
                  @click="
                    kayit_duzelt(Data.groupguid, DetayId), (AddEdit = 'Edit')
                  "
                  class="fas fa-pencil-alt"
                >
                </i>

                <i
                  style="margin-left:10px"
                  @click="sil(Data.groupguid)"
                  class="fas fa-trash-alt"
                >
                </i>
              </td>
            </tr>
          </tbody>
        </table>

        <br />
        <div
          v-if="AltDonemlerDetay.Onay == 0 || AltDonemlerDetay.Onay == null"
          class="col-sm-12"
        >
          <div class="text-sm-end">
            <button
              type="button"
              class="btn btn-danger btn-rounded mb-2 me-2"
              @click="toplu_sil()"
            >
              <i class="mdi mdi-delete-alert me-1"></i>
              {{ this.$t("StrPerfTablolarDetayParametreGiris.Page.TumunuSil") }}
            </button>
          </div>
        </div>
      </div>

      <b-modal
        id="StrPerfTablolarDetayParametreGiris"
        size="md"
        :title="this.AddEdit == 'Edit' ? 'Kayıt Düzenle' : 'Yeni Kayıt Ekle'"
        title-class="font-18"
        hide-footer
      >
        <Form @submit.prevent="onSubmit">
          <div v-for="(Data, index) in FormElemanlari" :key="index" class="row">
            <div
              v-if="Data.FieldType == 'Karakter' || Data.FieldType == 'Para'"
              class="col-md-12"
            >
              <b-form-group
                class="d-block"
                id=""
                label-cols-lg="4"
                :label="Data.FieldTitle"
                label-for="text"
              >
                <b-form-input
                  type="text"
                  v-model="FormData[index].Deger"
                  value=""
                ></b-form-input>
              </b-form-group>
            </div>

            <div v-if="Data.FieldType == 'Sayı'" class="col-md-12">
              <b-form-group
                class="d-block"
                id=""
                label-cols-lg="4"
                :label="Data.FieldTitle"
                label-for="text"
              >
                <b-form-input
                  type="number"
                  v-model="FormData[index].Deger"
                  value=""
                ></b-form-input>
              </b-form-group>
            </div>

            <div v-if="Data.FieldType == 'Tarih'" class="col-md-12">
              <b-form-group
                class="d-block"
                id=""
                label-cols-lg="4"
                :label="Data.FieldTitle"
                label-for="text"
              >
                <b-form-input
                  type="date"
                  v-model="FormData[index].Deger"
                  value=""
                ></b-form-input>
              </b-form-group>
            </div>

            <div v-if="Data.FieldType == 'Combobox'" class="col-md-10 mt-2">
              <b-form-group :label="Data.FieldTitle" label-for="text">
                <treeselect
                  :multiple="true"
                  :options="Data.ComboboxData"
                  placeholder="Seçiniz..."
                  v-model="FormData[index].Deger"
                />
              </b-form-group>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-10"></div>
            <div class="col-md-2">
              <button class="btn btn-primary text-sm-end" type="submit">
                Kaydet
              </button>
            </div>
          </div>
        </Form>
      </b-modal>

      <b-modal
        id="ExcelOku"
        size="lg"
        :title="this.AddEdit == 'Edit' ? 'Kayıt Düzenle' : 'Yeni Kayıt Ekle'"
        title-class="font-18"
        hide-footer
      >
        <button
          type="button"
          class="btn btn-success btn-rounded mb-2 me-2"
          @click="ExcelExport2('Detay Parametreleri', 'Detay Parametreleri')"
        >
          <i class="mdi mdi-file-export-outline me-1"></i>
          Şablonu İndir
        </button>
        <input
          class="form-control"
          @change="onChange"
          type="file"
          id="formFile"
        />

        <br />

        <div class="table-responsive">

          <table
            class="table table-striped table-bordered mb-0"
            ref="strdetayparametresablon"
          >
            <thead>
              <tr>
                <th v-for="(Data, index) in FormElemanlari" :key="index">
                  {{ Data.FieldTitle }}
                </th>
                <th v-if="gizle == 0">İşlem</th>
              </tr>
            </thead>

            <tr v-for="(DataSatir, index) in okunanverijson" :key="index">
              <td v-for="(Data, index2) in DataSatir" :key="index2">
                <div v-if="typeof Data == 'object'">
                  <b-form-group :label="Data.FieldTitle" label-for="text">
                    <treeselect
                      :multiple="true"
                      :options="
                        FormElemanlari[FormElemanlari.length - 1].ComboboxData
                      "
                      placeholder="Seçiniz..."
                      :value="Data"
                      @input="updateData(index, index2, $event)"
                    />
                  </b-form-group>
                </div>
                <div v-else>
                  {{ Data }}
                </div>
              </td>
              <td>
                <i
                  style="margin-left:10px"
                  @click="ExcelSil(index)"
                  class="fas fa-trash-alt"
                >
                </i>
              </td>
            </tr>
          </table>
        </div>
        <br />

        <button class="btn btn-primary" @click="parametre_kontrol(2)">
          Kaydet
        </button>
      </b-modal>


        <b-modal
        id="AvesisOku"
        size="lg"
        :title="'Avesisten Okunan Veri'"
        title-class="font-18"
        hide-footer
      >

        <br />

        <div class="table-responsive">
          <table
            class="table table-striped table-bordered mb-0"
            ref="strdetayparametresablon"
          >
            <thead>
              <tr>
                <th v-for="(Data, index) in FormElemanlari" :key="index">
                  {{ Data.FieldTitle }}
                </th>
                <th v-if="gizle == 0">İşlem</th>
              </tr>
            </thead>

            <tr v-for="(DataSatir, index) in okunanverijson" :key="index">
              <td v-for="(Data, index2) in DataSatir" :key="index2">
                <div v-if="typeof Data == 'object'">
                  <b-form-group :label="Data.FieldTitle" label-for="text">
                    <treeselect
                      :multiple="true"
                      :options="
                        FormElemanlari[FormElemanlari.length - 1].ComboboxData
                      "
                      placeholder="Seçiniz..."
                      :value="Data"
                      @input="updateData(index, index2, $event)"
                    />
                  </b-form-group>
                </div>
                <div v-else>
                  {{ Data }}
                </div>
              </td>
              <td>
                <i
                  style="margin-left:10px"
                  @click="ExcelSil(index)"
                  class="fas fa-trash-alt"
                >
                </i>
              </td>
            </tr>
          </table>
        </div>
        <br />

        <button class="btn btn-primary" @click="parametre_kontrol(2)">
          Kaydet
        </button>
      </b-modal>

   

    </div>

     <yukleniyor v-if="loading == 0"></yukleniyor>
     
  </Loader>
</template>
